export const DEFAULT_CLERK_VERIFICATION_COOLDOWN_SECONDS = 30;

export function getClerkErrorMessage(error) {
  if (typeof error === "string") return error;

  return (
    error?.errors?.[0]?.longMessage ||
    error?.errors?.[0]?.message ||
    error?.response?.data?.errors?.[0]?.long_message ||
    error?.response?.data?.errors?.[0]?.longMessage ||
    error?.response?.data?.errors?.[0]?.message ||
    error?.response?.data?.message ||
    error?.message ||
    ""
  );
}

export function getClerkErrorCode(error) {
  return (
    error?.errors?.[0]?.code ||
    error?.response?.data?.errors?.[0]?.code ||
    error?.code ||
    ""
  );
}

export function isClerkRateLimitError(error) {
  const code = String(getClerkErrorCode(error)).toLowerCase();
  const message = String(getClerkErrorMessage(error)).toLowerCase();
  const status = Number(error?.status || error?.response?.status || 0);

  return (
    status === 429 ||
    code.includes("rate_limit") ||
    code.includes("too_many_requests") ||
    message.includes("rate exceeded") ||
    message.includes("too many verification") ||
    message.includes("too many requests")
  );
}

export function getClerkRetryAfterSeconds(
  error,
  fallback = DEFAULT_CLERK_VERIFICATION_COOLDOWN_SECONDS
) {
  const headers = error?.response?.headers;
  const headerValue =
    headers?.get?.("retry-after") ||
    headers?.["retry-after"] ||
    headers?.["Retry-After"];
  const candidates = [
    error?.retryAfter,
    error?.retry_after,
    error?.errors?.[0]?.meta?.retry_after,
    error?.response?.data?.errors?.[0]?.meta?.retry_after,
    headerValue,
  ];

  const retryAfter = candidates
    .map((value) => Number(value))
    .find((value) => Number.isFinite(value) && value > 0);

  return Math.min(3600, Math.max(1, Math.ceil(retryAfter || fallback)));
}
